import { Instance } from 'mobx-state-tree';
import WidgetProcessor from '~/mst/models/widget/processor';
import actions from './actions';
import model from './model';
import views from './views';

const MapWidget = model.views(views).actions(actions);

export interface IMapWidget extends Instance<typeof MapWidget> {}

export default WidgetProcessor(MapWidget);
